import { IHttpService, IPromise } from "angular";
import { IInstanceSettings, IInstanceSettingsDto, IRegistryEntry } from "../../typings/board/Models";
import { InstanceSettingsService, INSTANCE_SETTINGS_SERVICE } from "../instance-settings/instance-settings.service"

export const DATA_DIRECT_SERVICE = "dataDirectService";

export class DataDirectService {

    static $inject = ["$http", INSTANCE_SETTINGS_SERVICE];
    constructor(private $http: IHttpService, private instanceSettingService: InstanceSettingsService) { }

    getSettings() {
        return this.instanceSettingService.getSettings().then((response) => { return response; });
    }

    dataDirectPassword(username: string, currentPassword: string, newPassword: string) {
        return this.instanceSettingService.dataDirectPassword(username, currentPassword, newPassword).then((response) => { return response; });
    }

    createODBCConfiguration(odbcName: string, dataSourceName: string): ng.IPromise<any> {
        return this.$http.get<any>("api/ODBC/CreateODBCConfiguration", { params: { odbcName: odbcName, dataSourceName: dataSourceName } });
    }

    deleteODBCConfiguration(name: string): ng.IPromise<any> {
        return this.$http.get<any>("api/ODBC/DeleteODBCConfiguration", { params: { name: name } });
    }

    machineName(): IPromise<string> {
        return this.$http.get<string>("api/dashboard/MachineId").then(response => response.data);
    }

    getExistingConfigurations(): IPromise<IRegistryEntry[]> {
        return this.$http.get<IRegistryEntry[]>("api/ODBC/GetExistingConfigurations").then(
            response => {
                return response.data
            },
            error => {
                return [];
            }
        );
    }

    updateODBCConfiguration(oldName: string, newName: string, dataSourceName: string): ng.IPromise<any> {
        return this.$http.get<any>("api/ODBC/EditODBCConfiguration", {
            params: {
                oldName: oldName,
                newName: newName,
                dataSourceName: dataSourceName
            }
        }).then(response => {
            return response.data;
        }, (reason) => {
            return reason;
        });
    }
}


// WEBPACK FOOTER //
// ./app/data-direct/data-direct.service.ts